export default "__VITE_ASSET__B3avc3X$__"